import { memo, useContext, useEffect, useRef, useState } from "react";
import "../../../css/wallet/Token/TokenSend.css";
import { useTranslation } from "react-i18next";
import { WalletContext } from "../WalletProvider.js";
import { TokenSendRequest } from "./TokenSendRequest.js";
import { useNavigate } from "react-router-dom";
import AddBankCard from "./AddBankCard.js";

function SendToken({ theme, setSendStatus, token }) {
  const { tokensInfo } = useContext(WalletContext);
  const [active, setActive] = useState(false);

  const { t } = useTranslation();

  const AddressInputRef = useRef(null);

  const [addressInputValue, setAddressInputValue] = useState(null);
  const [amountInputValue, setAmountInputValue] = useState(null);
  const [memoInputValue, setMemoInputValue] = useState(null);

  const [balanceStatus, setBalanceSatatus] = useState(false);
  const [usdtBlanaceStatusForFee, setUSDTBalanceStatusForFee] = useState(true);
  const [selectedUSDTNetwork, setSelectedUSDTNetwork] = useState(null)

  const [TokenSendRequestStatus, setTokenSendRequestStatus] = useState(false);

  const [sendTokenError, setSendTokenError] = useState({ "status": false, "text": "" })

  const tomanInfo = tokensInfo?.[0]?.tokens?.find(t => t.symbol === "IRR");
  const [showAddCard, setShowAddCard] = useState(false);


  const usdtToken = tokensInfo?.[0]?.tokens.find(
    (t) => t.symbol === "USDT"
  );

  const navigate = useNavigate();

  useEffect(() => {
    requestAnimationFrame(() => {
      setActive(true);
    });

    if (AddressInputRef.current) {
      setTimeout(() => {
        AddressInputRef.current.focus();
      }, 300);
    }
  }, []);

  const FEES = {
    trx: 2,
    gram: 0.2,
    t: 0,
  };

  const USDT_FEES = {
    TRC20: 16,   // TRX
    GRAM: 0.2,   // GRAM
    BEP20: 0.004, // BNB 
    ERC20: 0.001, // ETH 
  };

  const getFee = () => {
    if (token === "usdt") {
      return USDT_FEES[selectedUSDTNetwork] || 0;
    }

    return FEES[token] || 0;
  };

  const SYMBOLS = {
    t: "T",
    usdt: "USDT",
    trx: "TRX",
    gram: "GRAM",
  };


  const balance = () => {
    const amount = parseFloat(amountInputValue) || 0;

    const symbol = SYMBOLS[token];

    let balance = 0;

    if (token === "usdt") {
      balance =
        parseFloat(
          usdtToken?.networks.find(
            (n) => n.network === selectedUSDTNetwork
          )?.balance
        ) || 0;
    }

    else {
      balance =
        parseFloat(
          tokensInfo[0]?.tokens.find(
            (t) => t.symbol === symbol
          )?.balance
        ) || 0;
    }

    setBalanceSatatus(balance >= amount);

    if (token === "usdt") {

      let feeToken = "";
      let requiredFee = 0;

      if (selectedUSDTNetwork === "TRC20") {
        feeToken = "TRX";
        requiredFee = USDT_FEES.TRC20;
      }

      else if (selectedUSDTNetwork === "GRAM") {
        feeToken = "GRAM";
        requiredFee = USDT_FEES.GRAM;
      }

      else if (selectedUSDTNetwork === "BEP20") {
        feeToken = "BNB";
        requiredFee = USDT_FEES.BEP20;
      }

      else if (selectedUSDTNetwork === "ERC20") {
        feeToken = "ETH";
        requiredFee = USDT_FEES.ERC20;
      }

      if (feeToken) {
        const feeBalance =
          parseFloat(
            tokensInfo[0]?.tokens.find(
              (t) => t.symbol === feeToken
            )?.balance
          ) || 0;

        setUSDTBalanceStatusForFee(
          feeBalance >= requiredFee
        );

      }

      else {
        setUSDTBalanceStatusForFee(false);
      }
    }
  };

  useEffect(() => {
    balance();
  }, [amountInputValue, selectedUSDTNetwork, tokensInfo]);



  const getFeeText = () => {

    if (token !== "usdt") {
      return "";
    }

    if (!selectedUSDTNetwork) {
      return "";
    }

    if (selectedUSDTNetwork === "TRC20") {
      return ` (fee ${USDT_FEES.TRC20} TRX)`;
    }

    if (selectedUSDTNetwork === "GRAM") {
      return ` (fee ${USDT_FEES.GRAM} GRAM)`;
    }

    if (selectedUSDTNetwork === "BEP20") {
      return ` (fee ${USDT_FEES.BEP20} BNB)`;
    }

    if (selectedUSDTNetwork === "ERC20") {
      return ` (fee ${USDT_FEES.ERC20} ETH)`;
    }

    return "";
  };


  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setSendStatus(false);
          }, 300);
        }}
      ></div>
      <div className={`popupTokenSend ${theme} ${active ? "active" : ""}`}>
        <div className={`tokenSendHeader ${theme}`}>{t("Send ") + token.toUpperCase()}</div>

        <div className="tokenSendContent">


          {/* --- select network */}
          {
            token === "usdt" && (
              <div className="inputDiv">
                <div className="labelDiv">{t("Network")}</div>

                <select
                  className={`info_select ${theme}`}
                  value={selectedUSDTNetwork}
                  onChange={(e) => setSelectedUSDTNetwork(e.target.value)}
                >
                  <option value="">{t("Select Network")}</option>

                  {usdtToken?.networks.map((item, index) => (
                    item?.network == "TRC20" && (
                      <option key={index} value={item.network}>
                        {item.network} - {item.balance} USDT
                      </option>
                    )
                  ))}

                </select>
              </div>
            )
          }

          <div className="inputDiv">
            {
              token == "irr" ? (
                <>
                  <div className="labelDiv aiku7yak">
                    <span>{t("Address")}</span>
                    <span className="AddCartButton" onClick={() => setShowAddCard(true)}>{t("+ Add")}</span>
                  </div>

                  <select
                    className={`info_select ${theme}`}
                    onChange={(e) => setSelectedUSDTNetwork(e.target.value)}
                  >

                    <option value="">{t("Select Card")}</option>

                    {tomanInfo?.bank_cards?.map((card) => (
                      <option key={card.id} value={card.id}>
                        {card.bank_name} - {card.card_number}
                      </option>
                    ))}

                  </select>
                </>
              ) : (
                <>
                  <div className="labelDiv">{t("Address")}</div>

                  <input
                    className={`input ${theme}`}
                    ref={AddressInputRef}
                    onChange={(e) => {
                      setAddressInputValue(e.target.value);
                    }}
                  ></input>
                </>
              )
            }

          </div>


          <div className="inputDiv">
            <div className="labelDiv">{t("Amount")}</div>
            <input
              className={`input ${theme} ${amountInputValue && !balanceStatus && "error"}`}
              onChange={(e) => {
                setAmountInputValue(e.target.value);
              }}
            ></input>

            {amountInputValue && !balanceStatus && (
              <div className="inputErrorDiv">{t("Not enough balance")}</div>
            )}

            {amountInputValue && usdtBlanaceStatusForFee === false && (
              <div className="inputErrorDiv">
                {
                  selectedUSDTNetwork === "TRC20" &&
                  t("16 TRX is required for fee")
                }

                {
                  selectedUSDTNetwork === "GRAM" &&
                  t("0.2 GRAM is required for fee")
                }

                {
                  selectedUSDTNetwork === "BEP20" &&
                  t("BNB is required for fee")
                }

                {
                  selectedUSDTNetwork === "ERC20" &&
                  t("ETH is required for fee")
                }
              </div>
            )}
          </div>

          <div className="inputDiv">
            <div className="labelDiv">{t("Memo")}</div>
            <input
              className={`input ${theme}`}
              onChange={(e) => {
                setMemoInputValue(e.target.value);
              }}
            ></input>
          </div>

          {/* error */}
          {
            sendTokenError.status && (
              <div className="inputErrorDiv">{t(sendTokenError.text)}</div>
            )
          }

          <button
            className={`submit_button ${theme} ${addressInputValue && amountInputValue && balanceStatus && "active"}`}
            onClick={() => {
              if (addressInputValue && amountInputValue && balanceStatus && usdtBlanaceStatusForFee) {
                TokenSendRequest(
                  token,
                  addressInputValue,
                  amountInputValue,
                  memoInputValue,
                  setTokenSendRequestStatus,
                  setActive,
                  setSendStatus,
                  navigate,
                  setSendTokenError,
                  selectedUSDTNetwork
                );
              }
            }}
          >
            {!TokenSendRequestStatus ? (
              t(
                token === "trx"
                  ? "ContinueTRX"
                  : token === "gram"
                    ? "ContinueGRAM"
                    : token === "usdt"
                      ? "ContinueUSDT"
                      : "Continue"
              )
            ) : (
              <img
                src="/icons/loading.png"
                className={`icon ${theme} rotate`}
              ></img>
            )}
          </button>


          {showAddCard && (
            <AddBankCard
              theme={theme}
              setShowAddCard={setShowAddCard}
              onCardAdded={() => {
                window.location.reload();
              }}
            />
          )}
        </div>
      </div >
    </>
  );
}

export default SendToken;
